module.exports = "/images/new.png?f0689c1deeb8d144d096cc971385637b";